var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "635px",
    height: "466px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#125570",
    d: "M 516.5,3.5 C 345.333,3.16699 174.333,3.50033 3.5,4.5C 2.95691,4.44001 2.62358,4.10667 2.5,3.5C 174,2.16731 345.333,2.16731 516.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25a8df",
    d: "M 516.5,3.5 C 520.761,9.69268 524.761,16.026 528.5,22.5C 528.427,24.0269 529.094,25.0269 530.5,25.5C 530.427,27.0269 531.094,28.0269 532.5,28.5C 532.427,30.0269 533.094,31.0269 534.5,31.5C 534.427,33.0269 535.094,34.0269 536.5,34.5C 547.219,49.8906 557.552,65.5572 567.5,81.5C 567.427,83.0269 568.094,84.0269 569.5,84.5C 569.427,86.0269 570.094,87.0269 571.5,87.5C 571.427,89.0269 572.094,90.0269 573.5,90.5C 573.427,92.0269 574.094,93.0269 575.5,93.5C 575.427,95.0269 576.094,96.0269 577.5,96.5C 578.097,96.7352 578.43,97.2352 578.5,98C 536.033,166.446 492.699,234.28 448.5,301.5C 429.341,278.169 410.341,254.669 391.5,231C 406.649,207.854 421.649,184.687 436.5,161.5C 437.906,161.027 438.573,160.027 438.5,158.5C 443.779,149.228 449.446,140.228 455.5,131.5C 456.906,131.027 457.573,130.027 457.5,128.5C 462.779,119.228 468.446,110.228 474.5,101.5C 475.906,101.027 476.573,100.027 476.5,98.5C 477.669,95.4887 479.336,92.822 481.5,90.5C 482.906,90.0269 483.573,89.0269 483.5,87.5C 485.265,81.9633 483.599,77.7966 478.5,75C 337.833,74.6667 197.167,74.3333 56.5,74C 38.2092,51.2231 20.5425,28.0564 3.5,4.5C 174.333,3.50033 345.333,3.16699 516.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 528.5,22.5 C 529.906,22.9731 530.573,23.9731 530.5,25.5C 529.094,25.0269 528.427,24.0269 528.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 530.5,25.5 C 531.906,25.9731 532.573,26.9731 532.5,28.5C 531.094,28.0269 530.427,27.0269 530.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 532.5,28.5 C 533.906,28.9731 534.573,29.9731 534.5,31.5C 533.094,31.0269 532.427,30.0269 532.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 534.5,31.5 C 535.906,31.9731 536.573,32.9731 536.5,34.5C 535.094,34.0269 534.427,33.0269 534.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 567.5,81.5 C 568.906,81.9731 569.573,82.9731 569.5,84.5C 568.094,84.0269 567.427,83.0269 567.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 569.5,84.5 C 570.906,84.9731 571.573,85.9731 571.5,87.5C 570.094,87.0269 569.427,86.0269 569.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 483.5,87.5 C 483.573,89.0269 482.906,90.0269 481.5,90.5C 481.427,88.9731 482.094,87.9731 483.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 571.5,87.5 C 572.906,87.9731 573.573,88.9731 573.5,90.5C 572.094,90.0269 571.427,89.0269 571.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.753
    },
    fill: "#1c7fa7",
    d: "M 456.5,94.5 C 329.001,93.334 201.334,93.1673 73.5,94C 74.2524,94.6708 74.5858,95.5041 74.5,96.5C 73.1634,95.6851 72.1634,94.5185 71.5,93C 200.5,92.3333 329.5,92.3333 458.5,93C 457.956,93.7172 457.289,94.2172 456.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 573.5,90.5 C 574.906,90.9731 575.573,91.9731 575.5,93.5C 574.094,93.0269 573.427,92.0269 573.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25a8df",
    d: "M 456.5,94.5 C 444.95,114.064 432.95,133.397 420.5,152.5C 349.502,153.333 278.502,153.833 207.5,154C 202.574,156.353 200.74,160.186 202,165.5C 278.046,263.757 354.212,361.924 430.5,460C 404.833,460.667 379.167,460.667 353.5,460C 260.284,338.957 167.284,217.791 74.5,96.5C 74.5858,95.5041 74.2524,94.6708 73.5,94C 201.334,93.1673 329.001,93.334 456.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#174c64",
    d: "M 575.5,93.5 C 576.906,93.9731 577.573,94.9731 577.5,96.5C 576.094,96.0269 575.427,95.0269 575.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#174c64",
    d: "M 476.5,98.5 C 476.573,100.027 475.906,101.027 474.5,101.5C 474.427,99.9731 475.094,98.9731 476.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25a8de",
    d: "M 608.5,143.5 C 608.427,145.027 609.094,146.027 610.5,146.5C 610.427,148.027 611.094,149.027 612.5,149.5C 612.427,151.027 613.094,152.027 614.5,152.5C 614.427,154.027 615.094,155.027 616.5,155.5C 621.311,162.434 626.144,169.434 631,176.5C 631.667,177.833 631.667,179.167 631,180.5C 570.333,271.833 509.667,363.167 449,454.5C 375.471,360.605 302.304,266.438 229.5,172C 260.158,172.182 290.825,172.515 321.5,173C 362.454,224.29 403.788,275.29 445.5,326C 448.964,326.817 452.298,326.483 455.5,325C 458.03,320.987 460.696,317.154 463.5,313.5C 464.906,313.027 465.573,312.027 465.5,310.5C 476.779,291.894 488.446,273.561 500.5,255.5C 501.906,255.027 502.573,254.027 502.5,252.5C 511.337,237.487 520.67,222.82 530.5,208.5C 531.906,208.027 532.573,207.027 532.5,205.5C 533.669,202.489 535.336,199.822 537.5,197.5C 538.906,197.027 539.573,196.027 539.5,194.5C 548.337,179.487 557.67,164.82 567.5,150.5C 568.906,150.027 569.573,149.027 569.5,147.5C 575.689,136.466 582.522,125.799 590,115.5C 596.808,124.462 602.974,133.795 608.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#174c64",
    d: "M 457.5,128.5 C 457.573,130.027 456.906,131.027 455.5,131.5C 455.427,129.973 456.094,128.973 457.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 608.5,143.5 C 609.906,143.973 610.573,144.973 610.5,146.5C 609.094,146.027 608.427,145.027 608.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 610.5,146.5 C 611.906,146.973 612.573,147.973 612.5,149.5C 611.094,149.027 610.427,148.027 610.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 569.5,147.5 C 569.573,149.027 568.906,150.027 567.5,150.5C 567.427,148.973 568.094,147.973 569.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 612.5,149.5 C 613.906,149.973 614.573,150.973 614.5,152.5C 613.094,152.027 612.427,151.027 612.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 614.5,152.5 C 615.906,152.973 616.573,153.973 616.5,155.5C 615.094,155.027 614.427,154.027 614.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 438.5,158.5 C 438.573,160.027 437.906,161.027 436.5,161.5C 436.427,159.973 437.094,158.973 438.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 539.5,194.5 C 539.573,196.027 538.906,197.027 537.5,197.5C 537.427,195.973 538.094,194.973 539.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 532.5,205.5 C 532.573,207.027 531.906,208.027 530.5,208.5C 530.427,206.973 531.094,205.973 532.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 502.5,252.5 C 502.573,254.027 501.906,255.027 500.5,255.5C 500.427,253.973 501.094,252.973 502.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#18516a",
    d: "M 465.5,310.5 C 465.573,312.027 464.906,313.027 463.5,313.5C 463.427,311.973 464.094,310.973 465.5,310.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.52b2ffe1a0c6b43ec0cdf594c3a98e9e.svg";
export { ForwardRef as ReactComponent };